module.exports = __webpack_public_path__ + "assets/img/product_migraene@2x.2903bffc.jpg";